import React, { useContext, useState } from 'react';
import {
  DataGrid,
  Button,
  useResponsiveParams,
  Text,
  NotificationList,
} from 'quanta-ui';
import {
  faSave,
  faSpinner,
  faEnvelope,
  faSms,
  faDownload,
  faInfoCircle,
  faShare,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  GET_FIRE_POLICY_VAR_DETAILS,
  GET_FIRE_UPLOAD_POLICY_VAR_DETAILS,
  INTERMEDIARY_LIST,
  SEND_QUOTE_EMAIL_FIRE,
  SEND_QUOTE_PDF_FIRE,
  SEND_QUOTE_SMS_FIRE,
} from '../queries';
import { useQuery } from '@apollo/client';
// import Loading from '../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import Error from '../../../../../lib/layout/error';
import { Error } from 'quanta-flows/modules/layout';
import GetFieldUserName from './get-field-userName';
// import { ModalViewBreakupFire } from '../../../../common/view-breakup/exports';
import { ModalViewBreakupFire } from 'quanta-flows/modules/common/viewBreakUp';
// import Parse from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
// import { ConfigContext } from '../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
// import ModalSendEmail from '../../../../common/common-modals/modal-send-email';
import { ModalSendEmail } from 'quanta-flows/modules/common/modals';
// import ModalSendSms from '../../../../common/common-modals/modal-send-sms';
import { ModalSendSms } from 'quanta-flows/modules/common/modals';
import DownloadAndShare from './download-and-share';

export default function QuoteSummaryDetails({
  productCode,
  productName,
  lobName,
  lobCode,
  quoteNumber,
  riskCovers,
  quoteCreationDate,
  role,
  ...props
}) {
  const mutateQuery = useMutationQuery();
  const [alerts, setAlerts] = useState([]);
  const [showEmail, setShowEmail] = useState(false);
  const [showSms, setShowSms] = useState(false);
  const [showDownloadAndShare, setShowDownloadAndShare] =
    useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [showViewBreakup, setShowViewBreakup] = useState(false);


  const {
    loading,
    error,
    data: state,
  } = useQuery(GET_FIRE_POLICY_VAR_DETAILS);
  const { loading: loadingFireQuoteUploadDocs, error: errorFireQuoteUploadDocs, data: dataFireQuoteUploadDocs } = useQuery(GET_FIRE_UPLOAD_POLICY_VAR_DETAILS);

  const {
    loading: intermediaryListLoading,
    error: intermediaryListError,
    data: intermediaryListData,
  } = useQuery(INTERMEDIARY_LIST);

  const repeatForMobile = 2,
    repeatForDesktop = 1,
    repeatForIpad = 4;

  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
    for_iPad: repeatForIpad,
  });

  const { branding } = useContext(QuantaConfigContext);

  if (loading || intermediaryListLoading || loadingFireQuoteUploadDocs) return <Loading />;
  if (error || intermediaryListError || errorFireQuoteUploadDocs) return <Error  error={error || intermediaryListError || errorFireQuoteUploadDocs}/>;

  const { fireQuote, selectedIntermediary } = state;
  const { fireQuoteUploadDocs } = dataFireQuoteUploadDocs;
  const { myIntermediaries } = intermediaryListData;
  const getIntermediaryName = (code) => {
    return myIntermediaries
      ? myIntermediaries?.find(
          (intermediary) => intermediary?.intermediaryCode === code,
        )?.intermediaryName
      : code;
  };

  const getBusinessLocation = (intermediarycode, locationCode) => {
    return myIntermediaries && intermediarycode && locationCode
      ? myIntermediaries?.find(
          (intermediary) =>
            intermediary?.intermediaryCode === intermediarycode,
        )
        ? myIntermediaries
            ?.find(
              (intermediary) =>
                intermediary?.intermediaryCode === intermediarycode,
            )
            ?.businessLocations?.find(
              (location) => location?.code === locationCode,
            )?.name
        : locationCode
      : '';
  };

  const getBase64VarForFire = () => {
    //console.log("fireCover",fireQuote)
    let riskInput = [];
    // props?.riskLocationFormRef?.current?.values?.rawRiskData?.forEach(
      fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskCovers?.forEach(
      (r) => {
        let covers = [];
        r?.covers
          ?.filter(
            (c) =>
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType[
                `addOnCovers`
              ][c?.name]?.selected,
          )
          ?.forEach((c) => {
            const { selected, attributes, ...rest } = c;
            let attributesArr = [];
            c?.attributes?.forEach((attribute) => {
              attributesArr.push({
                ...attribute,
                value: attribute?.showOnScreen
                  ? `${
                    fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType[
                        `addOnCovers`
                      ][`${c?.name}`][`attributes`][
                        `${attribute?.name}`
                      ]
                    }`
                  : `${attribute?.defaultValue}`,
              });
            });
            covers?.push({
              ...rest,
              attributes: [...attributesArr],
            });
          });
        if (covers?.length !== 0) {
          riskInput.push({
            riskType: r?.riskType,
            covers,
          });
        }
      },
    );
    let clausefilter = []
    if(fireQuote?.tabDetails?.additionalTabDetails?.clauses?.Description)
    {
    for(let i =0;i < fireQuote?.tabDetails?.additionalTabDetails?.clauses?.defaultClauses?.length; i++)
    {
      if(fireQuote?.tabDetails?.additionalTabDetails?.clauses?.Description[i]?.toString() === 'Y')
      {
          clausefilter?.push(
          fireQuote?.tabDetails?.additionalTabDetails?.clauses?.defaultClauses[i]

        )
      }
    } 
    }
    let warrantyfilter = []
    if(fireQuote?.tabDetails?.additionalTabDetails?.warranties?.Description)
    {
    for(let i =0;i < fireQuote?.tabDetails?.additionalTabDetails?.warranties?.defaultWarranties.length; i++)
    {
      if(fireQuote?.tabDetails?.additionalTabDetails?.warranties?.Description[i]?.toString() === 'Y')
      {
        
        warrantyfilter.push(
          fireQuote?.tabDetails?.additionalTabDetails?.warranties?.defaultWarranties[i]

        )
      }
    } 
  }
    let exclusionfilter = []
    if(fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.Description)
    {
    for(let i =0;i < fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.defaultExclusions.length; i++)
    {
      if(fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.Description[i]?.toString() === 'Y')
      {
        exclusionfilter.push(
          fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.defaultExclusions[i]


        )
      }
    } 
  }
    let conditionfilter = []
    if(fireQuote?.tabDetails?.additionalTabDetails?.conditions?.Description)
    {
    for(let i =0;i < fireQuote?.tabDetails?.additionalTabDetails?.conditions?.defaultConditions.length; i++)
    {
      if(fireQuote?.tabDetails?.additionalTabDetails?.conditions?.Description[i]?.toString() === 'Y')
      {
        conditionfilter.push(
          fireQuote?.tabDetails?.additionalTabDetails?.conditions?.defaultConditions[i]

        )
      }
      }
    } 
    return {
      input: {
        intermediary: {
          intermediaryCode:
            fireQuote?.intermediaryDetails?.code ||
            selectedIntermediary?.intermediaryCode
              ? `${
                  fireQuote?.intermediaryDetails?.code ||
                  selectedIntermediary?.intermediaryCode
                }`
              : '',
          intermediaryName:  fireQuote?.intermediaryDetails?.name ||
            selectedIntermediary?.intermediaryName
              ? `${
                  fireQuote?.intermediaryDetails?.name ||
                  selectedIntermediary?.intermediaryName
                }`
              : '',
          locationCode:
            fireQuote?.intermediaryDetails?.location ||
            selectedIntermediary?.branchOfficeCode
              ? `${
                  fireQuote?.intermediaryDetails?.location ||
                  selectedIntermediary?.branchOfficeCode
                }`
              : '',
          fieldUserCode:
            fireQuote?.intermediaryDetails?.fieldUserCode ||
            selectedIntermediary?.fieldUserCode
              ? `${
                  fireQuote?.intermediaryDetails?.fieldUserCode ||
                  selectedIntermediary?.fieldUserCode
                }`
              : '',
        },
        lob: lobCode,
        product: productCode,
        productName: fireQuote?.customerDetails?.productKg?.toString() === 'Kotak Bharat Griha Raksha' ? 'Bharat Griha Raksha'
          : 'Griha Raksha Plus',
        quoteCreationDate:fireQuote?.quoteCreationDate,
        customer: {
          id: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.id
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.id
            : '',
          customerType: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.customerType
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.customerType
            : '',
          title: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.title?.value
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.title?.value
            : '',
          firstName: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.firstName
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.firstName
            : '',
          middleName: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.middleName
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.middleName
            : '',
          lastName: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.lastName
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.lastName
            : '',
          fullName: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.fullName
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.fullName
            : '',
          emailID: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.emailID
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.emailID
            : '',
          mobileNo: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.mobileNo
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.mobileNo
            : '',
          proposerDOB: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.proposerDOB
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.proposerDOB
            : '',
          orgName: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.orgName
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.orgName
            : '',
          orgType: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.orgType
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.orgType
            : '',
          contactName: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.contactName
            ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.contactName
            : '',
        },
        businessOfInsured:
          fireQuote?.tabDetails?.customerTabDetails?.customerDetails
            ?.businessOfInsured,
      
        
        policyType: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code
          ? `${fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code}`
          : '',
        tenure: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.tenure?.code,
        policyStartDate: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyStartDate,
        stageIndex: fireQuote?.currentTab,
       
        riskLocations:{
          
            riskLocationID:
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.riskLocationID,
            occupancyCodeValue: {
              code: fireQuote?.tabDetails
                ?.riskLocationTabDetails?.nonFloaterType?.occupancy?.code,
              value:'Dwellings',
                // fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                //   ?.occupancy?.value,
              occupancySection:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy
                  ?.occupancySection,
              occupancyRate:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy
                  ?.occupancyRate,
              riskCode:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy?.riskCode,
              rateCode:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy?.rateCode,
              riskGrade:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy?.riskGrade,
              riskGradeDefinition:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy
                  ?.riskGradeDefinition,
              riskPreference:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy
                  ?.riskPreference,
              gicClass:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy?.gicClass,
              stfiRate:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy?.stfiRate,
              rsmdRate:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.occupancy?.rsmdRate,
            },
            riskLocAddress: {
              addressLine1:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.addressDetails
                  ?.addressLine1,
              pinCode:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.addressDetails
                  ?.pincode,
              state:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.addressDetails
                  ?.state,
              city: fireQuote?.tabDetails
                ?.riskLocationTabDetails?.nonFloaterType
                ?.addressDetails?.city,
              district:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.addressDetails
                  ?.district,
              
              locationCode:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.addressDetails
                  ?.locationCode,
              
            },
            costOfConstruction:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.riskSumInsured
                ?.costOfConstruction),
            carpetArea:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.riskSumInsured
                ?.carpetArea),
              buildingValue:
              parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.riskSumInsured
                ?.buildingValue),
            additionalStructure:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.riskSumInsured
                ?.additionalStructure),
            totalBuildingSI:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.riskSumInsured
                ?.totalBuildingSI),
              generalContentSI:
              parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.stock?.generalContentSI),
            additionalContent:
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.stock?.additionalContent,
           additionalContentSI:
           parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.stock?.additionalContentSI),
            valuableContent:
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.stock
                ?.valuableContent,
        
        valuableContentSI:
        parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.stock?.valuableContentSI),

        totalContentSI:
        parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                    ?.stock
                    ?.totalContentSI),
        totalSumInsured:
            fireQuote?.tabDetails.customerTabDetails.policyTypeDetails.policyOrCoverType.code === 'Home Building Only'
              ?
        parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.riskSumInsured
                ?.totalBuildingSI)
              :
        parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                    ?.stock?.totalSumInsured),
        riskCovers: fireQuote?.riskcoverdata ? fireQuote?.riskcoverdata : [], // riskInput ? riskInput : [],
           loadingPct:
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.loadingAndDiscount
                ?.loadingPercentage,
            discountPct:
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                ?.loadingAndDiscount
                ?.discountPercentage,
           
            premium: {
              locNetPremium:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.locationPremium
                  ?.locationNetPremium,
              locGST:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                 ?.locationPremium
                  ?.locationGST,
              locTotalPremium:
                fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
                  ?.locationPremium
                  ?.locationTotalPremium
             
            },
          
        },
       
        
        
        
       
        clauses: {
          default: clausefilter?.length !== 0
          ? clausefilter
            : [],
          userDefined:
            fireQuote?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses?.filter(
              (udc) => udc,
            ),
        },
        warranties: {
          default: warrantyfilter?.length !== 0
          ? warrantyfilter
            : [],
          userDefined:
            fireQuote?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties?.filter(
              (udw) => udw,
            ),
        },
        exclusions: {
          default: exclusionfilter?.length !== 0
          ? exclusionfilter
            : [],
          userDefined:
            fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions?.filter(
              (ude) => ude,
            ),
        },
        conditions: {
          default: conditionfilter?.length !== 0
          ? conditionfilter
            : [],
          userDefined:
            fireQuote?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions?.filter(
              (udc) => udc,
            ),
        },
        finalisedPremium: {
          locNetPremium:
            fireQuote?.finalisedPremium?.locationNetPremium,
          locGST: fireQuote?.finalisedPremium?.locationGST,
          locTotalPremium:
            fireQuote?.finalisedPremium?.locationTotalPremium,
          // stampDuty: fireQuote?.finalisedPremium?.stampDuty,
        },
        uploadDocuments: fireQuoteUploadDocs?.documentDetails?.filter((document)=>document?.documentName && document?.documentBase64String)?.map((document)=> {
          return {
            documentType: {
              code: document?.documentName ? `${document?.documentName}`:'',
              value: document?.documentNameValue ? `${document?.documentNameValue}`:'',
            },
            documentName: document?.documentFileNameWithExtension
              ? `${document?.documentFileNameWithExtension}`
              : '',
            documentSize: document?.documentSizeinKB
              ? `${document?.documentSizeinKB}`
              : '',
            base64EncodedDoc: document?.documentBase64String
              ? `${document?.documentBase64String}`
              : '',
          }
        })
      },
      quoteNumber: fireQuote?.quoteNumber,
    };
  };

  let dataforDesktopView = [
    (getIntermediaryName(
    fireQuote?.intermediaryDetails?.code ||
      selectedIntermediary?.intermediaryCode,
    ) &&
      fireQuote?.intermediaryDetails?.code ||
    selectedIntermediary?.intermediaryCode ||
      selectedIntermediary?.intermediaryName)
      ? {
          label: 'Partner',
          text:
            fireQuote?.intermediaryDetails?.code ||
            selectedIntermediary?.intermediaryCode
              ? 
              `${getIntermediaryName(
                  fireQuote?.intermediaryDetails?.code ||
                    selectedIntermediary?.intermediaryCode,
            ) ? getIntermediaryName(
              fireQuote?.intermediaryDetails?.code ||
              selectedIntermediary?.intermediaryCode,
            ) : ''} (${`${fireQuote?.intermediaryDetails?.code ||
              selectedIntermediary?.intermediaryCode
              }`})`

              :
                 selectedIntermediary?.intermediaryName,
        }
      : '',
    fireQuote?.intermediaryDetails?.location ||
    selectedIntermediary?.branchOfficeCode ||
    selectedIntermediary?.branchOfficeName
      ? {
          label: 'Branch Office',
          text:
            fireQuote?.intermediaryDetails?.location ||
            selectedIntermediary?.branchOfficeCode
              ? getBusinessLocation(
                  fireQuote?.intermediaryDetails?.code ||
                    selectedIntermediary?.intermediaryCode,
                  fireQuote?.intermediaryDetails?.location ||
                    selectedIntermediary?.branchOfficeCode,
                )
              : selectedIntermediary?.branchOfficeName,
        }
      : undefined,
    fireQuote?.intermediaryDetails?.fieldUserCode ||
    selectedIntermediary?.fieldUserCode ||
    selectedIntermediary?.fieldUserName
      ? {
          label: 'Field User',
          text:
            fireQuote?.intermediaryDetails &&
            fireQuote?.intermediaryDetails?.fieldUserCode &&
            fireQuote?.intermediaryDetails?.fieldUserCode !== '' ? (
              <GetFieldUserName
                {...{
                  code:
                    fireQuote?.intermediaryDetails?.fieldUserCode ||
                    selectedIntermediary?.fieldUserCode,
                }}
              />
            ) : fireQuote?.intermediaryDetails.code !== '' &&
              fireQuote?.intermediaryDetails?.fieldUserCode === '' ? (
              ''
            ) : (
              selectedIntermediary.fieldUserName
            ),
        }
      : undefined,
    fireQuote.quoteNumber
      ? {
          label: 'Quotation Number',
          text: fireQuote.quoteNumber,
        }
      : null,
    fireQuote?.status
      ? {
          label: 'Quotation Status',
          text: fireQuote?.status,
        }
      : null,
    (fireQuote?.pendingMessage?.toString() !== '' )
      ? {
          label: 'Approval Reason',
          text: fireQuote?.pendingMessage,
        }
      : null,
    fireQuote?.proposalNumber
      ? {
          label: 'Proposal Number',
          text: fireQuote?.proposalNumber,
        }
      : null,
    fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails
      ?.policyStartDate
      ? {
          label: 'Policy Start Date',
          text: fireQuote?.tabDetails?.customerTabDetails
            ?.policyTypeDetails?.policyStartDate,
        }
      : null,
    fireQuote?.finalisedPremium?.locationTotalPremium
      ? {
          label: 'Total Quote Premium',
          text: (
            <Text className="flex space-x-3 mt-1">
              <Text type={'larger'} severity={'info'}>
                {CurrencyFormater(
                  fireQuote?.finalisedPremium?.locationTotalPremium,
                  true,
                  false,
                  branding,
                  true,
                )}
              </Text>
              <Text
                className={'quanta_link'}
                onClick={(_) => setShowViewBreakup(true)}
                type={'label'}
              >
                View Breakup
              </Text>
            </Text>
          ),
        }
      : null,
    {
      text: (
        <Button
          disabled={(!fireQuote?.quoteNumber || loadingDownload || role?.toString()?.toLowerCase() === 'underwriter' || fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'quote draft'|| fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'underwriter rejected'|| fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'pending uw approval') ? true: false}
          size="medium"
          className="mt-2 w-full h-10"
          flat={true}
          iconPre={<FontAwesomeIcon icon={faEnvelope} />}
          onClick={(e) => setShowEmail(true)}
        >
          Email Quote
        </Button>
      ),
    },
    {
      text: (
        <Button
          disabled={(!fireQuote?.quoteNumber || loadingDownload || role?.toString()?.toLowerCase() === 'underwriter' || fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'quote draft'|| fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'underwriter rejected'|| fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'pending uw approval') ? true: false }
          size="medium"
          className="mt-2 w-full h-10"
          flat={true}
          iconPre={<FontAwesomeIcon icon={faSms} />}
          onClick={(e) => setShowSms(true)}
        >
          Message Quote
        </Button>
      ),
    },
    {
      text: (
        <Button
          disabled={(!fireQuote?.quoteNumber || loadingDownload || role?.toString()?.toLowerCase() === 'underwriter' || fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'quote draft'|| fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'underwriter rejected'|| fireQuote?.status
          ?.toString()
          ?.toLowerCase() ===
          'pending uw approval') ? true: false }
          size="medium"
          className="mt-2 w-full h-10"
          flat={true}
          iconPre={
            <FontAwesomeIcon
              icon={loadingDownload ? faSpinner : faDownload}
              spin={loadingDownload}
            />
          }
          onClick={async (_) => {
            try {
              setLoadingDownload(true);
              let quotePDFBase64String = mutateQuery({
                mutation: SEND_QUOTE_PDF_FIRE,
                variables: getBase64VarForFire(),
              });
              let { data: dataBase64String } =
                await quotePDFBase64String;
              const { sendQuotePDFFireSA } = dataBase64String;
              const { base64Pdf: downloadBase64String } =
                sendQuotePDFFireSA;
              setLoadingDownload(false);

              let byteCharacters = atob(
                downloadBase64String.toString(),
              );
              let byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              let byteArray = new Uint8Array(byteNumbers);
              let file = new Blob([byteArray], {
                type: 'application/pdf;base64',
              });
              let fileURL = URL.createObjectURL(file);
              // window.open(fileURL);
              const downloadLink = document.createElement('a');
              const fileName = `${productName}-${fireQuote?.quoteNumber}.pdf`;
              downloadLink.href = fileURL;
              downloadLink.download = fileName;
              downloadLink.click();
              window.URL.revokeObjectURL(fileURL);
            } catch (error) {
              setAlerts([
                {
                  id: Date.now(),
                  content: (
                    <div className="flex flex-col w-full h-full">
                      <Text type="normal">{error.message}</Text>
                    </div>
                  ),
                  type: 'error',
                  timeout: null,
                  disableClose: false,
                },
              ]);
              setLoadingDownload(false);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
        >
          {loadingDownload ? `Downloading...` : `Download Quote`}
        </Button>
      ),
    },
  ].filter((d) => d);

  let dataforiPadView = [
    {
      label: 'Quotation Number/ Status',
      text: fireQuote?.quoteNumber ? (
        <Text> {fireQuote?.quoteNumber}</Text>
      ) : (
        <Text className="text-neutral-darker">Not Captured</Text>
      ),
    },
    {
      label: 'Quotation Status',
      text: fireQuote?.status ? (
        <Text> {fireQuote?.status}</Text>
      ) : (
        <Text className="text-neutral-darker">Not Captured</Text>
      ),
    },
    {
      label: 'Total Quote Premium',
      text: fireQuote?.finalisedPremium?.locationTotalPremium ? (
        <Text className="flex space-x-1.5 mt-1 items-end">
          <Text type={'larger'} severity={'info'}>
            {CurrencyFormater(
              fireQuote?.finalisedPremium?.locationTotalPremium,
              true,
              false,
              branding,
              true,
            )}
          </Text>
          <Text
            className="cursor-pointer flex flex-col justify-end mb-1"
            severity="info"
            onClick={(_) => setShowViewBreakup(true)}
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </Text>
        </Text>
      ) : (
        <Text className="text-neutral-darker">Not Captured</Text>
      ),
    },
    {
      colSpan: 1,
      text: (
        <Text className="flex justify-end">
          <Button
            flat
            type={'button'}
            size="small"
            onClick={() => {
              if (fireQuote?.quoteNumber && role?.toString()?.toLowerCase() !== 'underwriter') {
                setShowDownloadAndShare(true);
              }
            }}
            className={`w-40 mt-2 ${
              !fireQuote?.quoteNumber || role?.toString()?.toLowerCase() === 'underwriter'
                ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                : ''
            }`}
            iconPre={
                <FontAwesomeIcon
                  icon={faShare}
                  size="sm"
                  className="mr-1"
                />
            }
          >
            Download & Share
          </Button>
        </Text>
      ),
    },
  ].filter((d) => d);

  let dataforMobileView = [
    {
      label: 'Quotation Number',
      text: fireQuote?.quoteNumber ? (
        <Text> {fireQuote?.quoteNumber}</Text>
      ) : (
        <Text className="text-neutral-darker">Not Captured</Text>
      ),
    },
    {
      label: 'Quotation Status',
      text: fireQuote?.status ? (
        <Text> {fireQuote?.status}</Text>
      ) : (
        <Text className="text-neutral-darker">Not Captured</Text>
      ),
    },
    {
      label: 'Total Quote Premium',
      text: fireQuote?.finalisedPremium?.locationTotalPremium ? (
        <Text className="flex space-x-1.5 mt-1 items-center">
          <Text type={'larger'} severity={'info'}>
            {CurrencyFormater(
              fireQuote?.finalisedPremium?.locationTotalPremium,
              true,
              false,
              branding,
              true,
            )}
          </Text>
          <Text
            className="cursor-pointer flex flex-col justify-end mb-0.5"
            onClick={(_) => setShowViewBreakup(true)}
            severity="info"
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </Text>
        </Text>
      ) : (
        <Text className="text-neutral-darker">Not Captured</Text>
      ),
    },
    {
      colSpan: 1,
      text: (
        <Text className="flex justify-start">
          <Button
            flat
            type={'button'}
            size="small"
            onClick={() => {
              if (fireQuote?.quoteNumber && role?.toString()?.toLowerCase() !== 'underwriter') {
                setShowDownloadAndShare(true);
              }
            }}
            className={`w-40 mt-2 ${
              !fireQuote?.quoteNumber || role?.toString()?.toLowerCase() === 'underwriter'
                ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                : ''
            }`}
            iconPre={
                <FontAwesomeIcon
                  icon={faShare}
                  size="sm"
                  className="mr-1"
                />
            }
          >
            Download & Share
          </Button>
        </Text>
      ),
    },
  ].filter((d) => d);

  return (
    <>
      <div>
        <DataGrid
          data={
            repeat === repeatForDesktop
              ? dataforDesktopView
              : repeat === repeatForMobile
              ? dataforMobileView
              : dataforiPadView
          }
          repeat={repeat}
          textType="normal"
          className="w-full"
          nullData={() => {
            return (
              <Text type="normal" severity="neutral-darker">
                Not Captured
              </Text>
            );
          }}
        />
      </div>
      <NotificationList {...{ items: alerts }} />
      <ModalSendEmail
        {...{
          showEmail,
          setShowEmail,
          initialEmail: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.emailID ? `${fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.emailID}`:'',
          SEND_EMAIL_QUERY: SEND_QUOTE_EMAIL_FIRE,
          getPayLoad: (email, ccEmailIds) => {
            return {
              ...getBase64VarForFire(),
              email,
              ccEmailIds,
            };
          },
        }}
      />
      <ModalSendSms
        {...{
          showSms,
          setShowSms,
          initialMobile: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.mobileNo ? `${fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customer?.mobileNo}`:'',
          SEND_SMS_QUERY: SEND_QUOTE_SMS_FIRE,
          getPayLoad: (
            mobile,
            alternateMobileNos,
            whatsappNo,
            modes,
          ) => {
            return {
              ...getBase64VarForFire(),
              mobile,
              alternateMobileNos,
              whatsappNo,
              modes,
            };
          },
        }}
      />
      <DownloadAndShare
        {...{
          showDownloadAndShare,
          setShowDownloadAndShare,
          fireQuoteInput: getBase64VarForFire(),
          fireQuote: fireQuote,
          product_code: productCode,
          lob_code: lobCode,
          lob_name: lobName,
          quote_number: quoteNumber,
          product_name: productName,
        }}
      />
      <Text>
        <ModalViewBreakupFire
          {...{
            setShowViewBreakup,
            showViewBreakup,
            title: 'Total premium breakup for quote',
            productName:
              fireQuote?.productKg?.toString() === 'Kotak Bharat Griha Raksha'
                ? 'Bharat Griha Raksha' : 'Griha Raksha Plus',
            locationPremium: {
              locationNetPremium:
                fireQuote?.finalisedPremium?.locationNetPremium,
              locationGST: fireQuote?.finalisedPremium?.locationGST,
              locationTotalPremium:
                fireQuote?.finalisedPremium?.locationTotalPremium,
              stampDuty: fireQuote?.finalisedPremium?.stampDuty,
            },
          }}
        />
      </Text>
    </>
  );
}
